import React, { Component } from 'react'
import _ from 'lodash'
import gql from "graphql-tag"
import { Formik, Field, FormikProps } from 'formik'
import * as Yup from 'yup'
import { useMutation } from "@apollo/react-hooks"

import { SpinnerButton } from 'components/common/button'
import { TextField, ImageField } from 'components/common/formik'
import { useGlobalContext, GlobalContextProps } from 'components/context'
import {
		saveOrganisation as MutationType,
		saveOrganisationVariables as MutationVariables 
} from './gql-types/saveOrganisation'
import { useDispatch } from 'react-redux';
import { createNotification } from 'state/actions/userInterface';


const SAVE_ORG = gql`
	mutation saveOrganisation(
		$id: ID!,
		$name: String!,
		$logo: Upload
	) {
		organisation_Update(input: {
			id: $id
			name: $name,
			logo: $logo,
		}) {
			object {
				id
				name
				logo
			}
		}
	}
`

type ValuesType = {
	name: string
	logo: File | null
}

const AddTeam = () => {
	const [mutate, {loading}] = useMutation<MutationType, MutationVariables>(SAVE_ORG)
	const { organisation } = useGlobalContext()
	const dispatch = useDispatch()
	return (
		<Formik
			initialValues={_.pick(organisation, ['id', 'name', 'logo'])}
			validationSchema={Yup.object().shape({
				name: Yup.string().required('Required'),
				logo: ImageField.validator
			})}
			onSubmit={(values, actions) => {
				mutate({variables: { ...values, id: organisation.id }}).then(() => {
					actions.resetForm()
					dispatch(createNotification({
						'content': 'Organisation saved',
					}))
				}).catch((r) => {
					console.error(r)
					actions.setFieldError('all', 'There was a problem saving data')
				}).finally(() => {
					actions.setSubmitting(false)
				})
			}}
		>
			{ (props: FormikProps<ValuesType>) => {
				const { handleSubmit } = props
				return (
					<div className="page-form-container">
						<form onSubmit={handleSubmit} className="common-form">
							<Field
								name="name"
								placeholder={"Name"}
								component={TextField}
							/>
							<Field
								title="logo"
								name="logo"
								component={ImageField}
							/>
							<div style={{display: 'flex', justifyContent: 'space-around', width: 200}}>
								<SpinnerButton loading={loading} type="submit">
									Save
								</SpinnerButton>
							</div>
						</form>
					</div>
				)
			}}
		</Formik>
	)
}

export default AddTeam